<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				请假申请-{{ruleForm.id != null && ruleForm.id != '' ? '修改' : '新增'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<!-- 查询框 -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<div @click="txbm()">
								<el-form-item label="姓名" prop="staff_name" style="margin-top:80px;width:80%">
									<el-input style="width:595px" v-model="ruleForm.staff_name" onfocus="this.blur();">
									</el-input>
								</el-form-item>
							</div>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="请假类型" prop="dictionaries_id" style="width:80%">
								<el-select v-model="ruleForm.dictionaries_id" style="width:595px" placeholder="请选择"
									clearable>
									<el-option v-for="item in qjList" :key="item.id" :label="item.data"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="开始时间" prop="start_date">
								<el-date-picker v-model="ruleForm.start_date" style="width:595px" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="结束时间" prop="end_date">
								<el-date-picker v-model="ruleForm.end_date" style="width:595px" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="请假时长(小时)" prop="leave_duration" style="width:80%">
								<el-input style="width:595px" v-model="ruleForm.leave_duration"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="请假事由" prop="leave_reason">
								<el-input type="textarea" v-model="ruleForm.leave_reason" :rows="2" style="width:595px"
									placeholder="请输入请假事由">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12"> 
							<el-form-item label="照片" prop="region">
								<el-upload :action="$globals.http + '/file/upload'" list-type="picture-card"
									:on-preview="handlePictureCardPreview" :limit="1" :on-remove="handleRemove"
									:on-success="handleAvatarSuccess">
									<i class="el-icon-plus"></i>
								</el-upload>
								<el-dialog :visible.sync="dialogVisible">
									<img width="100%" :src="ruleForm.bank_photo" alt="">
								</el-dialog>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item style="margin-left:200px">
						<el-button type="goon" @click="Add" v-show="ruleForm.id == null || ruleForm.id == ''">保存
						</el-button>
						<el-button type="goon" @click="UpdateAuditor" v-show="ruleForm.id != null && ruleForm.id != ''">
							修改
						</el-button>
						<el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>
		<el-dialog title="选择请假人" :visible.sync="dialogVisibles" width="40%" :center="true" :close-on-click-modal="false"
			:show-close="false">
			<el-row>
				<organizeStaff ref="organizeStaff" type="radio" :accordion="false" @commit="saveChange"
					:staff_id_prop="ruleForm.staff_id"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<!-- <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="2" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id"></SelectAuditor>
		</el-dialog> -->

	</div>
</template>

<script>
	import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
	export default {
		components: {
			organizeStaff: organizeStaff,
			SelectAuditor: SelectAuditor,
		},
		props: ["organizeList", "qjList"],
		data() {
			return {
				//页面相关
				dialogVisible: false,
				dialogVisibles: false,
				dialogAuditorVisible: false,
				dialogImageUrl: '',

				//表单数据
				ruleForm: {
					id: '',
					staff_id: '',
					staff_name: '',
					dictionaries_id: '',
					start_date: '',
					end_date: '',
					leave_duration: '',
					leave_reason: '',
					leave_url: '',
					applicant_id: '',
					examineDetailsList: [],
				},

				//暂存数据
				object: {
					staff_id: "",
					staff_name: "",
					project_id: "",
					project_name: ""
				},

				//表单验证
				rules: {
					staff_name: [{
						required: true,
						message: '请选择用户！',
						trigger: 'blur'
					}],
					dictionaries_id: [{
						required: true,
						message: '请选择请假类型',
						trigger: 'blur'
					}],
					start_date: [{
						required: true,
						message: '请选择开始时间',
						trigger: 'blur'
					}],
					end_date: [{
						required: true,
						message: '请选择结束时间',
						trigger: 'blur'
					}],
					leave_duration: [{
						required: true,
						message: '请输入请假时长',
						trigger: 'blur'
					}],
					leave_reason: [{
						required: true,
						message: '请输入请假事由',
						trigger: 'blur'
					}],
				},
			};
		},
		methods: {
			txbm() {
				this.dialogVisibles = true;
				this.showtxbm = true;
			},
			//设置确定
			saveChange(e) {
				this.ruleForm.staff_id = e.staff_id;
				this.ruleForm.staff_name = e.staff_name;
				this.dialogVisibles = false;
			},
			handleAvatarSuccess(res, file) {
				this.ruleForm.leave_url = res.data.fileUrl;
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			//返回
			Return() {
				this.dialogAuditorVisible = false;
				this.$parent.Return();
				this.$parent.Find();
				this.trash();
			},
			//添加
			AddAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Add() {
				var url = 'StaffLeave/insert';
				var record = {
					staff_id: this.ruleForm.staff_id,
					dictionaries_id: this.ruleForm.dictionaries_id,
					start_date: this.ruleForm.start_date,
					end_date: this.ruleForm.end_date,
					leave_duration: this.ruleForm.leave_duration,
					leave_reason: this.ruleForm.leave_reason,
					leave_url: this.ruleForm.leave_url,
					examineDetailsList: this.ruleForm.examineDetailsList,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
						return this.$globals.user.id;
					} else {
						this.$message.warning(data);
					}
				}
			},
			//修改
			UpdateAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.ruleForm.examineDetailsList = [];
						this.dialogAuditorVisible = true;
						this.$refs['SelectAuditor'].initialize();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Update() {
				var url = 'StaffLeave/update';
				var record = {
					id: this.ruleForm.id,
					staff_id: this.ruleForm.staff_id,
					dictionaries_id: this.ruleForm.dictionaries_id,
					start_date: this.ruleForm.start_date,
					end_date: this.ruleForm.end_date,
					leave_duration: this.ruleForm.leave_duration,
					leave_reason: this.ruleForm.leave_reason,
					leave_url: this.ruleForm.leave_url,
					examineDetailsList: this.ruleForm.examineDetailsList,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
						return this.$globals.user.id;
					} else {
						this.$message.warning(data);
					}
				}
			},
			trash() {
				this.ruleForm.id = '';
				this.ruleForm.start_id = '';
				this.ruleForm.staff_name = '';
				this.ruleForm.dictionaries_id = '';
				this.ruleForm.start_date = '';
				this.ruleForm.end_date = '';
				this.ruleForm.leave_duration = '';
				this.ruleForm.leave_reason = '';
				this.ruleForm.leave_url = '';
				this.ruleForm.applicant_id = '';
				this.ruleForm.examineDetailsList = [];
			},
		},
		created() {
			this.ruleForm = this.$parent.ruleForm;
		},
		watch: {
			"ruleForm.staff_id"(newValue) {
				this.object.staff_id = newValue;
			},
			"ruleForm.staff_name"(newValue) {
				this.object.staff_name = newValue;
			},
		}
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// Qjsq_add.vue?49fa0c09